import script from "./OrangTuaPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OrangTuaPage.vue?vue&type=script&setup=true&lang=js"

import "./OrangTuaPage.vue?vue&type=style&index=0&id=51e78188&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51e78188"]])

export default __exports__